import { render, staticRenderFns } from "./DayTemplateCreationCard.vue?vue&type=template&id=67206a92&"
import script from "./DayTemplateCreationCard.vue?vue&type=script&lang=js&"
export * from "./DayTemplateCreationCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports